import { ShieldCheck } from 'lucide-react'

const LOGO_FILTER = 'brightness(0) saturate(100%) invert(8%)'

// Casca visual padrão das telas de acesso (mesmo estilo do Login).
export default function AuthShell({ titulo, subtitulo, children, rodape }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-offwhite relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #ff6c00 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      <div className="w-full max-w-md relative z-10">
        <div className="flex justify-center mb-6">
          <img src="/logothe.png" alt="The Conect" style={{ maxHeight: 56, filter: LOGO_FILTER }} />
        </div>
        <div className="relative">
          <div className="absolute -inset-1 rounded-3xl blur-xl" style={{ background: 'linear-gradient(135deg, #ffcc0033, #ff6c0033)' }} />
          <div className="relative bg-white rounded-3xl border border-neutral-200 overflow-hidden" style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.10)' }}>
            <div className="h-1.5" style={{ background: 'linear-gradient(90deg, #ffcc00 0%, #ff6c00 100%)' }} />
            <div className="p-8">
              <div className="text-center mb-6">
                <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full mb-3 text-xs font-bold uppercase tracking-wider"
                  style={{ background: 'linear-gradient(135deg, #fff5cc, #ffe4bf)', color: '#b34c00', border: '1px solid rgba(255,108,0,0.2)' }}>
                  <ShieldCheck size={12} /> The Conect
                </span>
                <h2 className="text-2xl font-heading font-extrabold text-graphite">{titulo}</h2>
                {subtitulo && <p className="text-sm text-gray-500 mt-1">{subtitulo}</p>}
              </div>
              {children}
            </div>
          </div>
        </div>
        {rodape && <div className="text-center mt-5 text-sm">{rodape}</div>}
      </div>
    </div>
  )
}

export const inputCls =
  'w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 outline-none focus:border-accent-500 focus:bg-white transition'
export const btnCls =
  'w-full rounded-xl text-white font-bold py-3 disabled:opacity-60 transition hover:brightness-105'
export const btnStyle = { background: 'linear-gradient(135deg, #ffcc00, #ff6c00)' }
